import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import React from "react";
import NewMoveInForm from "./components/NewMoveInForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default (props) => {
  const open = props.open;
  const handleClose = props.handleClose;
  const properties = props.properties;
  const submitNewMoveIn = props.submitNewMoveIn;

  const handleAction = (data, isBillingSame, unitInfo) => {
    submitNewMoveIn(data, isBillingSame, unitInfo);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="md"
      keepMounted
      aria-labelledby="manual-move-in-dialog-title"
      aria-describedby="manual-move-in-dialog-description"
    >
      <DialogTitle id="manual-move-in-dialog-title">
        Manual Move In
      </DialogTitle>
      <DialogContent sx={{ width: "100%", "&.MuiDialogContent-root": { overflow: "visible" } }}>
        <NewMoveInForm
          action={handleAction}
          handleClose={handleClose}
          properties={properties}
        />
      </DialogContent>
    </Dialog>
  );
};
